<template>
  <v-container class="my-5" fluid>
    <v-card class="mx-auto my-4 modern-card" max-width="1200" elevation="3">
      <v-row align="center" class="pa-4">
        <!-- Logo Section -->
        <v-col cols="12" md="5" class="d-flex justify-center align-center">
          <v-img
            :src="getImageUrl(aboutData.image)"
            alt="Company Logo"
            class="company-logo"
            max-height="400"
          ></v-img>
        </v-col>

        <!-- Profile Section -->
        <v-col cols="12" md="7" class="pa-5">
          <v-card-title class="text-h3" style="color: #002250; font-weight: bold; ">
            {{ aboutData.title }}
          </v-card-title>
          <v-card-text style="color: #002250; font-size: 1.2rem; line-height: 1.8; white-space: normal;text-align: justify;">
            <div v-html="formattedText"></div>
          </v-card-text>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "About",
  computed: {
  formattedText() {
    if (!this.aboutData.text) return "";
    
    // Preserve paragraph breaks and line breaks
    return this.aboutData.text
      .split(/\n\n+/) // Split by double newlines (paragraphs)
      .map(paragraph => `<p>${paragraph.replace(/\n/g, "<br>")}</p>`) // Wrap paragraphs and preserve single line breaks
      .join(""); // Join the paragraphs
  }
},

  data() {
    return {
      aboutData: {
        image: null,
        title: "About Us",
        text: "",
      },
      loading: false,
    };
  },
  async created() {
    await this.fetchAboutData();
  },
  methods: {
    async fetchAboutData() {
      this.loading = true;
      try {
        const response = await this.$axios.get("/about");
        if (response.data && response.data.data.length > 0) {
          this.aboutData = response.data.data[0];
        }
      } catch (error) {
        console.error("Error fetching About Us content:", error);
      } finally {
        this.loading = false;
      }
    },
    getImageUrl(imageName) {
      return `${this.$urlImage}storage/images/${imageName}`;
    },
    scrollToContact() {
      this.$router.push({ name: "Contact" });
    },
  },
};
</script>

<style scoped>
/* Updated Image Styling */
.company-logo {
  width: 100%;
  height: auto; /* Maintain aspect ratio */
  border-radius: 15px; /* Subtle rounding for modern look */
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
}

/* Responsive Typography */
.v-card-title {
  font-family: "Roboto", sans-serif;
}

.v-card-text {
  font-family: "Open Sans", sans-serif;
}
</style>
